<template>
    <Modal title="编辑短剧列表" v-model="dialogVisible" width="900px" class="episode-list-dialog" :top="100">
        <!-- 剧场信息 -->
        <div class="theater-info">
            <span class="label">剧场：</span>
            <span class="value" :title="theaterName">{{ theaterName }}</span>
            <Button type="primary" icon="md-add" class="add-btn" @click="handleAdd">
                添加
            </Button>
        </div>

        <!-- 剧集列表表格 -->
        <Table :data="episodeList" :columns="episodeColumns" :max-height="400" :loading="episodeLoading">
            <template slot="playUrl" slot-scope="{ row }">
                <img v-if="row.playUrl" :src="row.playUrl" alt="封面" class="cover-img">
                <span v-else class="no-cover">无封面</span>
            </template>
            <template slot="sort" slot-scope="{ row }">
                <div class="sort-value">
                    <Input v-model.number="row.sort" type="number" v-if="row.isEditSort" placeholder="请输入排序值"
                        size="small" @on-blur="handleSortBlur(row)" />
                    <span v-else>{{ row.sort || 0 }}</span>
                    <Icon type="md-create" class="edit-sort-icon" @click="handleEditSort(row)" />
                </div>
            </template>
            <template slot="action" slot-scope="{ row }">
                <Button size="small" type="error" @click="handleDelete(row)">
                    删除
                </Button>
            </template>
        </Table>

        <!-- 分页 -->
        <div class="pagination-wrapper">
            <Pages :page="page" :func="handlePageChange" />
        </div>

        <!-- 底部按钮 -->
        <template slot="footer">
            <Button @click="handleCancel">取消</Button>
            <Button type="primary" @click="handleConfirm">确定</Button>
        </template>

        <!-- 添加剧集弹窗（多选） -->
        <Modal title="添加短剧" v-model="addVisible" width="900px" class="add-episode-dialog" :z-index="2000" :top="100">
            <!-- 搜索区域 -->
            <div class="search-area">
                <Input v-model="playId" placeholder="短剧id" class="search-input" clearable />
                <Input v-model="playName" placeholder="短剧名称" class="search-input" clearable />
                <Button type="primary" @click="handleSearch">搜索</Button>
                <Button @click="handleReset">重置</Button>
            </div>

            <!-- 可选剧集列表 -->
            <Table :data="searchList" :columns="searchColumns" :max-height="400"
                @on-selection-change="handleSelectionChange" :loading="loading">
                <template slot="fileUrl" slot-scope="{ row }">
                    <img v-if="row.fileUrl" :src="row.fileUrl" alt="封面" class="cover-img-sm">
                    <span v-else class="no-cover">无封面</span>
                </template>
            </Table>

            <!-- 分页 -->
            <div class="pagination-wrapper">
                <Pages :page="searchPageInfo" :func="handleSearchPageChange" />
            </div>
            <template slot="footer">
                <Button @click="handleAddCancel">取消</Button>
                <Button type="primary" @click="handleAddSubmit">提交</Button>
            </template>
        </Modal>
    </Modal>
</template>

<script>
import Pages from '@/components/pages'
import { getSeriesList } from '@/api/theater-list'
import { addConfigSeries, deleteConfigSeries, getTheaterPlayNotIn } from '@/api/theater-list'

export default {
    name: 'EpisodeListDialog',
    components: {
        Pages
    },
    props: {
        id: {
            type: [String, Number],
        },
        visible: {
            type: Boolean,
            default: false
        },
        theaterName: {
            type: String,
            default: ''
        },
        langId: {
            type: [String, Number],
        },
        isUpdate: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            dialogVisible: false,
            addVisible: false,
            loading: false,
            episodeLoading: false,
            playId: '',
            playName: '',
            isAllSelected: false,
            checkedList: [],
            // 分页相关
            page: {
                current: 1,
                size: 10,
                total: 0
            },

            // 搜索分页
            searchPageInfo: {
                current: 1,
                size: 10,
                total: 0
            },

            // 剧集表格列配置
            episodeColumns: [
                {
                    title: '短剧id',
                    key: 'playId',
                    width: 100
                },
                {
                    title: '短剧名称',
                    key: 'playName',
                    width: 200
                },
                {
                    title: '短剧中文名称',
                    key: 'chineseName',
                    width: 200
                },
                {
                    title: '封面图',
                    slot: 'playUrl',
                    width: 120
                },
                {
                    title: '排序值',
                    slot: 'sort',
                    width: 150
                },
                {
                    title: '操作',
                    slot: 'action',
                }
            ],

            // 搜索表格列配置
            searchColumns: [
                {
                    type: 'selection',
                    width: 60
                },
                {
                    title: '短剧id',
                    key: 'playId',
                    width: 100
                },
                {
                    title: '短剧名称',
                    key: 'playName',
                },
                {
                    title: '短剧中文名称',
                    key: 'chinesePlayName',
                },
                {
                    title: '封面图',
                    slot: 'fileUrl',
                    width: 120
                }
            ],

            // 剧集数据
            episodeList: [],

            // 可选剧集列表
            searchList: []
        }
    },
    computed: {
    },
    watch: {
        visible(val) {
            this.dialogVisible = val
        },
        dialogVisible(val) {
            this.$emit('update:visible', val)
            if (val) {
                this.getSeriesListFn()
            }
        },
    },
    mounted() {
    },
    methods: {
        // 获取tiktok小程序剧场短剧列表分页查询
        getSeriesListFn() {
            this.episodeLoading = true
            // 从接口获取数据 分页查询
            getSeriesList({ current: this.page.current, size: this.page.size, id: this.id }).then((r) => {
                if (r.code === 200) {
                    const data = r.data
                    this.episodeList = data.records || []
                    this.episodeList.forEach((e,) => {
                        e.isEditSort = false
                    })
                    this.page.total = data.total || 0
                }
            }).finally(() => {
                this.episodeLoading = false
            })
        },
        handlePageChange(page) {
            this.page.current = page || 1
            this.getSeriesListFn()
        },
        handleSearchPageChange(page) {
            this.searchPageInfo.current = page || 1
            this.getSearchListFn()
        },
        handleAdd() {
            this.playId = ''
            this.playName = ''
            this.searchPageInfo.current = 1
            this.searchList.forEach(item => {
                item.selected = false
            })
            this.addVisible = true
            this.getSearchListFn()

        },
        getSearchListFn() {
            const params = {
                current: this.searchPageInfo.current,
                size: this.searchPageInfo.size,
                // theaterId: this.id,
                playName: this.playName,
                playId: this.playId,
                langId: this.langId
            }
            this.loading = true
            getTheaterPlayNotIn(params).then((r) => {
                if (r.code === 200) {
                    this.searchList = r.data.records || []
                    this.searchList.forEach(item => {
                        item.selected = false
                    })
                    this.searchPageInfo.total = r.data.total || 0
                }
            }).finally(() => {
                this.loading = false
            })
        },
        handleSearch() {
            this.searchPageInfo.current = 1
            this.getSearchListFn()
        },
        handleReset() {
            this.playId = ''
            this.playName = ''
            this.searchPageInfo.current = 1
            this.searchList.forEach(item => {
                item.selected = false
            })
            this.getSearchListFn()
        },
        handleSelectAll(val) {
            this.searchList.forEach(item => {
                item.selected = val
            })
        },
        handleSelectionChange(val) {
            this.checkedList = val
        },
        handleDelete(item) {
            this.$Modal.confirm({
                title: '提示',
                content: '是否确认删除该短剧?',
                onOk: () => {
                    deleteConfigSeries([item.id]).then((r) => {
                        if (r.code === 200) {
                            this.$Message.success('删除成功!')
                            this.getSeriesListFn()
                            this.$emit('update:isUpdate', true)
                        }
                    })
                },
                onCancel: () => {
                    this.$Message.info('已取消删除')
                }
            })
        },
        handleEditSort(item) {
            this.episodeList.forEach(e => {
                e.isEditSort = false
            })
            item.isEditSort = true
        },
        handleSortBlur(item) {
            item.isEditSort = false
            addConfigSeries({
                seriesList: [item]
            }).then((r) => {
                if (r.code === 200) {
                    this.$Message.success('排序成功')
                    this.getSeriesListFn()
                    this.$emit('update:isUpdate', true)
                }
            })

        },
        handleCancel() {
            this.dialogVisible = false
        },
        handleConfirm() {
            this.$emit('confirm', this.episodeList)
            this.dialogVisible = false
        },
        handleAddCancel() {
            this.addVisible = false
        },
        handleAddSubmit() {
            if (this.checkedList.length === 0) {
                this.$Message.warning('请选择要添加的短剧')
                return
            }
            this.checkedList.forEach(item => {
                item.theaterConfigId = this.id
            })
            addConfigSeries({
                seriesList: this.checkedList
            }).then((r) => {
                if (r.code === 200) {
                    this.addVisible = false
                    this.$Message.success('成功添加短剧')
                    this.getSeriesListFn()
                    this.$emit('update:isUpdate', true)
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.episode-list-dialog {
    .ivu-modal-body {
        padding: 20px;
        max-height: 70vh;
        overflow-y: auto;
    }
}

.theater-info {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebeef5;

    .label {
        width: 75px;
        font-size: 14px;
        color: #606266;
    }

    .value {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .add-btn {
        margin-left: auto;
    }
}

.select-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ebeef5;

    th,
    td {
        padding: 12px 16px;
        border: 1px solid #ebeef5;
        text-align: left;
        font-size: 14px;
    }

    th {
        background-color: #fafafa;
        font-weight: 600;
        color: #303133;
    }
}

.cover-img {
    width: 60px;
    height: 80px;
    object-fit: cover;
    border-radius: 4px;
}

.cover-img-sm {
    width: 50px;
    height: 70px;
    object-fit: cover;
    border-radius: 4px;
}

.no-cover {
    font-size: 12px;
    color: #999;
}

.sort-value {
    display: flex;
    align-items: center;
    gap: 8px;

    .edit-sort-icon {
        color: #409eff;
        font-size: 14px;
        cursor: pointer;
        margin-left: 5px;
    }

    .edit-sort-icon:hover {
        color: #67c23a;
    }
}

.pagination-wrapper {
    margin-top: 16px;
}

.add-episode-dialog {
    position: relative !important;
    z-index: 2000;

    .ivu-modal-body {
        padding: 20px;
        max-height: 70vh;
        overflow-y: auto;
    }
}

.search-area {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .search-input {
        width: 200px;
    }
}

.col-id {
    width: 100px;
}

.col-name {
    width: 200px;
}

.col-chinese-name {
    width: 200px;
}

.col-cover {
    width: 120px;
}

.col-sort {
    width: 100px;
}

.col-action {
    width: 100px;
}

.col-checkbox {
    width: 50px;
}
</style>
